import { defineMessages } from 'react-intl';

export default defineMessages({
    dismissAction: {
        defaultMessage: 'Dismiss',
        description: 'Action to dismiss onboarding modal.',
        id: 'cv.portal.onboarding.request-type.dismiss-action',
    },
    editAction: {
        defaultMessage: 'Edit',
        description: 'Action to go to request editting page.',
        id: 'cv.portal.onboarding.request-type.edit-action',
    },
    requestTypeSpotlightBody: {
        defaultMessage:
            'Save time by asking the right questions upfront. {editRequestType} to change what fields customers see.',
        description: 'Message for edit request types spotlight card',
        id: 'cv.portal.onboarding.request-type.body',
    },
    requestTypeSpotlightHeading: {
        defaultMessage: 'Reduce back-and-forth',
        description: 'title for edit request types spotlight card',
        id: 'cv.portal.onboarding.request-type.heading',
    },
    editRequestType: {
        defaultMessage: 'Edit request types',
        description: 'text for edit request types',
        id: 'cv.portal.onboarding.request-type.edit-request-type',
    },
});
